import React, { useState } from 'react'
import { Box, Typography, Divider } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import CreateB2COrder from './CreateV2/CreateB2COrder'
import CreateB2COrderRVP from './CreateRVPV2/CreateB2COrder'
import BulkOrderCreate from './create/bulkordercreate'
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography'
import { NAVY, BORDER, SUBTLE, WHITE, PRIMARY_BLUE, SUCCESS, withOpacity } from '../../styles/foundation/colors'
import { pageContainerSx } from '../../styles/patterns'

// Single entry point for the three D2C shipment-creation flows, previously three separate
// sidebar entries (/create-order, /create-order-rvp, /bulk-order-create). Those paths are
// still registered and render the same components standalone, so existing links keep working.
const TABS = [
  { key: 'forward', label: 'Forward Shipment', icon: <LocalShippingOutlinedIcon />, color: PRIMARY_BLUE },
  { key: 'reverse', label: 'Reverse Shipment', icon: <AssignmentReturnOutlinedIcon />, color: SUCCESS },
  { key: 'bulk', label: 'Bulk Shipments', icon: <UploadFileOutlinedIcon />, color: '#ff9800' },
]

const CreateShipment = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const initial = TABS.findIndex((t) => t.key === searchParams.get('tab'))
  const [active, setActive] = useState(initial >= 0 ? initial : 0)

  const handleTab = (i) => {
    setActive(i)
    // Keep the tab in the URL so a specific flow can be linked to / reloaded into.
    setSearchParams({ tab: TABS[i].key }, { replace: true })
  }

  return (
    <Box sx={pageContainerSx}>
      {/* Flow tabs */}
      <Box sx={{ bgcolor: WHITE, border: `1px solid ${BORDER}`, borderRadius: '12px', mb: 2, overflow: 'hidden' }}>
        <Box sx={{ display: 'flex' }}>
          {TABS.map((t, i) => {
            const isActive = active === i
            return (
              <React.Fragment key={t.key}>
                {i > 0 && <Divider orientation='vertical' flexItem sx={{ borderColor: BORDER }} />}
                <Box
                  onClick={() => handleTab(i)}
                  sx={{
                    flex: '1 1 auto', minWidth: 130, py: 1.25, px: 2, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                    borderBottom: isActive ? `3px solid ${t.color}` : '3px solid transparent',
                    bgcolor: isActive ? withOpacity(t.color, 0.06) : 'transparent',
                    transition: 'all 0.15s',
                    '&:hover': { bgcolor: withOpacity(t.color, 0.04) },
                  }}
                >
                  <Box sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    width: 30, height: 30, borderRadius: '8px',
                    bgcolor: isActive ? withOpacity(t.color, 0.12) : withOpacity(t.color, 0.07),
                    color: isActive ? t.color : SUBTLE,
                    '& .MuiSvgIcon-root': { fontSize: 17 },
                  }}>
                    {t.icon}
                  </Box>
                  <Typography sx={{
                    fontFamily: FONT, fontSize: SIZE['2xs'],
                    fontWeight: isActive ? WEIGHT.bold : WEIGHT.medium,
                    color: isActive ? NAVY : SUBTLE, lineHeight: 1.2,
                  }}>
                    {t.label}
                  </Typography>
                </Box>
              </React.Fragment>
            )
          })}
        </Box>
      </Box>

      {/* Tab content — each form keeps its own PageTitle, APIs and internal layout */}
      {active === 0 && <CreateB2COrder embedded />}
      {active === 1 && <CreateB2COrderRVP embedded />}
      {active === 2 && <BulkOrderCreate shipmentType='B2C' embedded />}
    </Box>
  )
}

export default CreateShipment
